// it's not core- it's reqs for core.
// the following set up window.rwgps.*, some of which are called directly in
// rwgps-ui code. this file is included in every render_core call-- planner
// renders get routes-ui-new on top of this.
require('expose?T!expose?Translations!../../../public/javascripts/translations.js')
require('expose?$!expose?jQuery!../../../public/javascripts/jquery-2.2.3.js')
require('expose?_!../../../public/javascripts/underscore-amd-1.4.4.js')
require('expose?Backbone!../../../public/javascripts/backbone-amd-1.0.0.js')

window.Routes = window.Routes || {};

/**
* Access/extend namespaces within the rwgps object. Generally for scoping view-specific code.
* Convention for namespaces is lower camel, e.g. scheduledReports.show
* @method ns
* @static
* @param {String} ns Period-separated namespace, e.g. foo.bar.baz.
* @param {Object | Function} obj If an object, extends the namespace with it. If a function, runs the function in the context of the namespace, and if the function returns an object, extends the namespace with that return value.
* @return {Object} The resulting namespace. rwgps.ns('foo.bar.baz') returns rwgps.foo.bar.baz after ensuring it exists.
*/
// all namespaces get this as their basic object
var baseNsObj = {
    ns: function () {
        return this._ns;
    },
};
function ns(ns, obj) {
    var nsResolved = resolveNamespace(ns);
    if (obj) {
        if (_.isFunction(obj)) obj = obj.apply(nsResolved);
        if (obj !== undefined) _.extend(resolveNamespace(ns), obj);
        // by convention a property named init will execute after dom ready,
        // but only for the active namespace
        // TODO: uncomment when you uncomment the other activeNamespace stuff
        //if(ns == rwgps.activeNamespace() && obj.init) $(obj.init);
    }
    return nsResolved;
}
// namespaces are specified as period-separated strings like so: foo.bar.baz
// they resolve to something like rwgps.foo.bar.baz respectively
// objects are created if they do not exist - in other words, nested namespaces are created upon declaration
function resolveNamespace(nsStr) {
    var nsResolved = rwgps,
    nsStrMemo;
    _.each(nsStr.split("."), function (x) {
        nsStrMemo = nsStrMemo === undefined ? x : nsStrMemo + "." + x;
        if (nsResolved[x] === undefined) nsResolved[x] = _.extend({ _ns: nsStrMemo }, baseNsObj);
        nsResolved = nsResolved[x];
    });
    return nsResolved;
}

window.rwgps = window.rwgps || {};
_.extend(window.rwgps, {
    ns: ns,
});

require('../../../public/javascripts/rails.js')
require('../../../public/javascripts/application.js')

require('../../../public/javascripts/postcards/postcard.js')



// WEBPACK FOOTER //
// ./app/assets/javascripts/core-reqs.js